import { LuBug, LuClipboardList, LuCode, LuFileText, LuPalette, LuRocket, LuSearch, LuShield, LuTarget, LuTrendingUp, LuUsers } from "react-icons/lu";

export const GEOHeroData = {
  backgroundImage: "/images/serviceBanners/GEO_Banner_New.webp",
  whiteImage: "/images/serviceBanners/GEO_Banner_whiteNew.webp",
  subTitle: "Generative Engine Optimization Services",
  title: (
    <>
      Maximize Brand Visibility with
      <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-600 to-purple-600 dark:from-cyan-400 dark:to-purple-600">Generative Engine Optimization (GEO)</span>
    </>
  ),
  description:
    "We build strategic GEO solutions that improve your brand visibility across AI-powered search platforms, strengthen content authority, and help your business appear in relevant AI-generated answers to drive qualified traffic, stronger discoverability, and sustainable digital growth.",
  primaryButton: {
    title: "Get a Free Quote",
    onClick: () => console.log("Get Started clicked"),
  },
  secondaryButton: {
    title: "View Our Work",
    onClick: () => console.log("View Our Work clicked"),
  },
  featureData: [
    {
      icon: "/images/services/website/high_performance.webp",
      title: "AI Search Visibility",
      desc: "Optimize website content to improve visibility across AI-powered search engines and generative platforms.",
      iconColor: "#a855f7",
    },
    {
      icon: "/images/services/website/responsive.webp",
      title: "Generative Search Optimization",
      desc: "Analyze user queries and conversational search intent to target topics that AI engines are more likely to surface.",
      iconColor: "#22d3ee",
    },
    {
      icon: "/images/services/website/secure.webp",
      title: "Content Authority",
      desc: "Create structured, authoritative content designed to improve discoverability in AI-generated responses.",
      iconColor: "#a855f7",
    },
    {
      icon: "/images/services/website/clean_code.webp",
      title: "Sustainable AI Discoverability",
      desc: "Strengthen brand entities, topical relevance, and contextual signals to improve trust across generative search platforms.",
      iconColor: "#34d399",
    },
  ],
  floatingIcons: [
    {
      image: "/images/services/website/nodejs.webp",
      top: "16%",
      right: "8%",
      containerSize: 80,
      iconSize: 60,
      glowColor: "rgba(59,130,246,0.35)",
      iconGlow: "rgba(59,130,246,0.9)",
    },
    {
      image: "/images/services/website/reactjs.svg",
      top: "8%",
      right: "16%",
      containerSize: 70,
      iconSize: 50,
      glowColor: "rgba(59,130,246,0.35)",
      iconGlow: "rgba(59,130,246,0.9)",
    },
    {
      image: "/images/services/website/python.svg",
      top: "20%",
      right: "22%",
      containerSize: 60,
      iconSize: 40,
      glowColor: "rgba(59,130,246,0.35)",
      iconGlow: "rgba(59,130,246,0.9)",
    },
  ],
};

export const geoAboutData = [
  {
    title: "Build Stronger Visibility Across Generative Search",
    content: (
      <>
        Generative Engine Optimization is becoming essential for businesses that want their information to be accurately understood and referenced by AI platforms. Unlike
        traditional optimization that mainly focuses on rankings, Generative Engine Optimization Services require brands to present reliable, well-supported, and context-rich
        information that AI systems can confidently interpret. Tycho Technologies develops GEO Services around content credibility, factual consistency, original insights, and
        business expertise. This approach helps organizations create stronger digital signals through expert content, verified claims, and trustworthy information that can improve
        the chances of being referenced in AI-generated responses.
      </>
    ),
  },
  {
    title: "Create Credible and Research-Driven Content",
    content: (
      <>
        As a Generative Engine Optimization Company, we focus on improving information depth and usefulness across your website. This includes creating research-backed resources,
        comparison pages, industry insights, case studies, statistics, and updated service information that clearly answer user queries. Businesses searching for a Generative
        Engine Optimization Agency need more than basic content optimization. Content freshness, source attribution, editorial accuracy, and clear subject expertise can help
        generative platforms evaluate your website with greater confidence.
      </>
    ),
  },
  {
    title: "Strengthen Brand Consistency Across Digital Sources",
    content: (
      <>
        Our Generative Engine Optimization Services in India help businesses improve how their brand and expertise appear across multiple digital touchpoints. Tycho Technologies
        combines GEO planning with{" "}
        <a href="https://tychotechnologies.com/digital-marketing-services-india" className="text-cyan-400 underline hover:text-cyan-300">
          Digital Marketing Services India
        </a>{" "}
        strategies to build a connected presence across search engines, AI platforms, directories, and industry websites. As a Generative Engine Optimization Company in India, we
        also review third-party mentions, business listings, publications, and brand information to reduce inconsistencies and create stronger supporting signals around your
        services and expertise.
      </>
    ),
  },
  {
    title: "Improve Regional Relevance and Qualified Discovery",
    content: (
      <>
        Our Generative Engine Optimization Services in Delhi NCR are designed for businesses that want stronger regional relevance without limiting wider AI visibility. A GEO
        Company in Delhi NCR should understand how location context, customer needs, service expertise, and regional search behaviour influence AI-generated results. We also align
        GEO initiatives with{" "}
        <a href="https://tychotechnologies.com/seo-content-strategy-services-india" className="text-cyan-400 underline hover:text-cyan-300">
          SEO Company India
        </a>{" "}
        practices to support both organic visibility and AI-assisted discovery. By improving evidence quality, information consistency, content maintenance, and market relevance,
        businesses can build stronger authority and attract more qualified users through emerging generative search experiences.
      </>
    ),
  },
];

export const geoDevelopSolutionsAndProcessData = {
  buildSubtitle: "WHAT WE BUILD",
  buildTitle: "Strategic GEO Solutions for Stronger AI Search Visibility",
  buildCards: [
    {
      title: "AI Search Optimization",
      desc: "Optimize website content to improve visibility across AI-powered search engines and generative platforms.",
      icon: LuSearch,
      colorClass: "text-[#00d2ff]",
      bgClass: "bg-[#00d2ff]/10",
      borderClass: "border-[#00d2ff]/20 hover:border-[#00d2ff]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(0,210,255,0.25)]",
    },
    {
      title: "Search Intent Mapping",
      desc: "Analyze user queries and conversational search intent to target topics that AI engines are more likely to surface.",
      icon: LuTarget,
      colorClass: "text-[#3b82f6]",
      bgClass: "bg-[#3b82f6]/10",
      borderClass: "border-[#3b82f6]/20 hover:border-[#3b82f6]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(59,130,246,0.25)]",
    },
    {
      title: "Generative Content Strategy",
      desc: "Create structured, authoritative content designed to improve discoverability in AI-generated responses.",
      icon: LuFileText,
      colorClass: "text-[#a855f7]",
      bgClass: "bg-[#a855f7]/10",
      borderClass: "border-[#a855f7]/20 hover:border-[#a855f7]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(168,85,247,0.25)]",
    },
    {
      title: "Entity Authority Building",
      desc: "Strengthen brand entities, topical relevance, and contextual signals to improve trust across generative search platforms.",
      icon: LuShield,
      colorClass: "text-[#06b6d4]",
      bgClass: "bg-[#06b6d4]/10",
      borderClass: "border-[#06b6d4]/20 hover:border-[#06b6d4]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(6,182,212,0.25)]",
    },
    {
      title: "Content Optimization Framework",
      desc: "Build a structured roadmap for topic clusters, semantic coverage, answer-focused content, and ongoing GEO improvements.",
      icon: LuClipboardList,
      colorClass: "text-[#6366f1]",
      bgClass: "bg-[#6366f1]/10",
      borderClass: "border-[#6366f1]/20 hover:border-[#6366f1]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(99,102,241,0.25)]",
    },
    {
      title: "AI Visibility Optimization",
      desc: "Optimize content signals to increase brand mentions, qualified traffic, engagement, and conversions from AI-driven search experiences.",
      icon: LuTrendingUp,
      colorClass: "text-[#d946ef]",
      bgClass: "bg-[#d946ef]/10",
      borderClass: "border-[#d946ef]/20 hover:border-[#d946ef]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(217,70,239,0.25)]",
    },
  ],
  processSubtitle: "Our Strategic GEO Growth Roadmap",
  processTitle: "How We Build Sustainable AI Search Authority",
  processSteps: [
    {
      step: "01",
      title: "AI Visibility Audit",
      description: "Evaluate your current content, brand mentions, and visibility across generative search platforms.",
      icon: LuUsers,
    },
    {
      step: "02",
      title: "Query & Intent Mapping",
      description: "Identify conversational queries, user intent, and high-value topics relevant to AI-driven search.",
      icon: LuClipboardList,
    },
    {
      step: "03",
      title: "Content Optimization",
      description: "Structure and optimize content to improve relevance, clarity, authority, and AI discoverability.",
      icon: LuPalette,
    },
    {
      step: "04",
      title: "Entity Strengthening",
      description: "Improve brand, service, and topical entity signals to build stronger trust across AI search engines.",
      icon: LuCode,
    },
    {
      step: "05",
      title: "Answer-Focused Enhancement",
      description: "Optimize headings, FAQs, summaries, and content sections to increase inclusion in AI-generated answers.",
      icon: LuBug,
    },
    {
      step: "06",
      title: "Performance Monitoring",
      description: "Track AI visibility, brand mentions, referral traffic, and content performance to support continuous GEO growth.",
      icon: LuRocket,
    },
  ],
  benefitsSubtitle: "WHY BUSINESSES CHOOSE OUR GEO STRATEGY",
  benefitsTitle: "Building Long-Term AI Search Authority",
  benefits: [
    "AI search visibility optimization",
    "Entity and topical authority building",
    "Answer-focused content structure",
    "Schema and semantic optimization",
    "Conversational query targeting",
  ],
  logoImage: "/images/serviceBanners/DigitalMarketingLatest.webp",
  whiteLogoImage: "/images/serviceBanners/digitalMarketingLatestW.webp",
};

export const geoServices = [
  {
    icon: <LuSearch size={36} />,
    title: "AI Search Visibility",
    description: "Optimize content signals to increase brand mentions and visibility across generative AI platforms.",
    image: "/images/MobileAppDevelopment/Android-Development.png",
    link: "/generative-engine-optimization-services-india",
  },
  {
    icon: <LuFileText size={36} />,
    title: "Content Authority Building",
    description: "Create research-backed, structured content that AI systems can confidently reference and cite.",
    image: "/images/MobileAppDevelopment/iOS-Custom.png",
    link: "/generative-engine-optimization-services-india",
  },
  {
    icon: <LuShield size={36} />,
    title: "Entity & Semantic Optimization",
    description: "Strengthen brand entities, topical relevance, and contextual signals for higher AI trust.",
    image: "/images/MobileAppDevelopment/Hybrid-Dev.png",
    link: "/generative-engine-optimization-services-india",
  },
];

export const geoFaqData = [
  {
    q: "What is Generative Engine Optimization (GEO)?",
    a: "Generative Engine Optimization (GEO) is the process of optimizing website content so AI-powered search platforms can better understand, reference, and present your brand in generated answers.",
  },
  {
    q: "How are Generative Engine Optimization (GEO) Services different from traditional SEO?",
    a: "Generative Engine Optimization (GEO) Services focus on AI visibility, brand mentions, content credibility, and contextual relevance, while traditional SEO mainly focuses on search rankings, organic traffic, and keyword performance.",
  },
  {
    q: "Why should businesses invest in GEO Services?",
    a: "GEO Services help businesses improve visibility across AI-powered search experiences, strengthen brand authority, increase relevant mentions, and attract users who discover services through generative search platforms.",
  },
  {
    q: "How can a Generative Engine Optimization (GEO) Company improve AI visibility?",
    a: "A Generative Engine Optimization (GEO) Company improves content structure, factual accuracy, topical depth, entity signals, source credibility, and contextual relevance to make business information easier for AI systems to understand.",
  },
  {
    q: "Why choose Tycho Technologies for Generative Engine Optimization (GEO) Services in India?",
    a: "Tycho Technologies provides Generative Engine Optimization (GEO) Services in India with strategies focused on AI discoverability, content authority, brand consistency, search intent, and qualified business growth.",
  },
];

export const geoPortfolioData = {
  subtitle: "OUR WORK",
  title: "GEO Projects We're Proud Of",
  buttonText: "View All Projects",
  buttonLink: "#all-projects",
  apps: [
    {
      title: "AI Visibility Suite",
      badge: "GEO Platform",
      badgeColor: "bg-[#00d2ff]/10 text-[#00d2ff] border-[#00d2ff]/20",
      desc: "A comprehensive platform for monitoring and optimizing brand presence across generative AI search engines.",
      downloads: "50K+",
      rating: "4.9",
      image: "/images/MobileAppDevelopment/foodie_express.png",
    },
    {
      title: "Content Authority Engine",
      badge: "Content Platform",
      badgeColor: "bg-[#a855f7]/10 text-[#a855f7] border-[#a855f7]/20",
      desc: "Research-driven content system that builds topical authority and improves AI citation rates.",
      downloads: "120K+",
      rating: "4.8",
      image: "/images/MobileAppDevelopment/finmate.png",
    },
    {
      title: "Entity Graph Builder",
      badge: "Semantic Tool",
      badgeColor: "bg-[#3b82f6]/10 text-[#3b82f6] border-[#3b82f6]/20",
      desc: "Tool for mapping and strengthening brand entities and semantic relationships for generative engines.",
      downloads: "80K+",
      rating: "4.7",
      image: "/images/MobileAppDevelopment/travelgo.png",
    },
  ],
};
